export default __webpack_public_path__ + "static/media/UnitOfMeasureLogo.6d3613a3.svg";